"use strict";
import n from "./index.es144.js";
function o(t, s, i, c, e) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", s && (this.code = s), i && (this.config = i), c && (this.request = c), e && (this.response = e, this.status = e.status ? e.status : null);
}
n.inherits(o, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: n.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const u = o.prototype, R = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  R[t] = { value: t };
});
Object.defineProperties(o, R);
Object.defineProperty(u, "isAxiosError", { value: !0 });
o.from = (t, s, i, c, e, E) => {
  const r = Object.create(u);
  n.toFlatObject(t, r, function(a) {
    return a !== Error.prototype;
  }, (a) => a !== "isAxiosError");
  const h = t && t.message ? t.message : "Error", l = s == null && t ? t.code : s;
  return o.call(r, h, l, i, c, e), t && r.cause == null && Object.defineProperty(r, "cause", { value: t, configurable: !0 }), r.name = t && t.name || "Error", E && Object.assign(r, E), r;
};
export {
  o as default
};
//# sourceMappingURL=index.es155.js.map
